import React, { memo } from 'react';
import T from 'i18n-react';
import MorningImage from '../../../../../images/meals/morning.png';
import NoonImage from '../../../../../images/meals/noon.png';
import NightImage from '../../../../../images/meals/night.png';
import type { TimingType } from '../index';
import { TIMINGS } from '../constants';

const getImageSrc = (timing: TimingType) => {
  if (timing === TIMINGS.MORNING) return MorningImage;
  if (timing === TIMINGS.NOON) return NoonImage;
  return NightImage;
};

type TimingIconProps = {
  timing: TimingType,
};

const TimingIcon = memo(({ timing }: TimingIconProps) => {
  const imageSrc = getImageSrc(timing);

  return (
    <img
      src={imageSrc}
      width={20}
      alt={T.translate(`planPage.planMeals.timings.${timing}`)}
    />
  );
});

export default TimingIcon;
